import '.ab{position:relative;}.ssr-plugin'
import '.ca{display:inline-flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.dr{align-self:flex-start;}.ssr-plugin'
import '.ds{padding:3px;}.ssr-plugin'
import '.dt{background:var(--palette-blue-50);}.ssr-plugin'
import '.du{border:0.5px solid var(--gray-200);}.ssr-plugin'
import '.cn{border-radius:0.75rem;}.ssr-plugin'
import '.bx{position:absolute;}.ssr-plugin'
import '.dv{top:3px;}.ssr-plugin'
import '.bg{left:0px;}.ssr-plugin'
import '.dw{width:0px;}.ssr-plugin'
import '.dx{height:calc(100% - 6px);}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.dy{border:0.5px solid var(--gray-300);}.ssr-plugin'
import '.dz{border-radius:calc(0.75rem - 3px);}.ssr-plugin'
import '.e0{box-shadow:0 1px 3px rgba(0, 0, 0, 0.08);}.ssr-plugin'
import '.cm{pointer-events:none;}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.e2{gap:0.375rem;}.ssr-plugin'
import '.e3{padding-block:6px;}.ssr-plugin'
import '.e4{padding-inline:18px;}.ssr-plugin'
import '.cr{background:transparent;}.ssr-plugin'
import '.c1{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.dd{user-select:none;}.ssr-plugin'
import '.e5{white-space:nowrap;}.ssr-plugin'
import '.at{flex:1;}.ssr-plugin'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

const PILL_TRANSITION =
  'left 0.28s cubic-bezier(0.34, 1.3, 0.64, 1), width 0.28s cubic-bezier(0.34, 1.3, 0.64, 1)'

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const pillRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const updatePill = useCallback(() => {
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedOption,
    )
    const activeEl = itemRefs.current[selectedIndex]
    const pill = pillRef.current

    if (!activeEl || !pill) {
      return
    }

    pill.style.left = `${activeEl.offsetLeft}px`
    pill.style.width = `${activeEl.offsetWidth}px`
  }, [options, selectedOption])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    updatePill()

    const observer = new ResizeObserver(() => {
      updatePill()
    })
    observer.observe(container)

    return () => observer.disconnect()
  }, [updatePill])

  return (
    <styled.div className="ab ca t dr ds dt du cn"
      ref={containerRef}
      style={{
        ...style,
      }}
    >
      <div className="bx dv bg dw dx do dy dz e0 cm"
        ref={pillRef}
        aria-hidden="true"
        style={{
          transition: PILL_TRANSITION,}}
      />
      {options.map((option, index) => {
        const isActive = selectedOption === option.value

        return (
          <styled.button className="ab e1 a t ax e2 e3 e4 cr c1 dz a1 dd e5 at"
            key={String(option.value)}
            type="button"
            ref={(element) => {
              itemRefs.current[index] = element
            }}
            onClick={() => setSelectedOption(option.value)}
            style={{
              ...(!isActive && {
                '&:hover span': {
                  color: 'var(--brand-secondary)',
                },
              }),
              ...option.style,
            }}
          >
            <Text.Medium
              color={
                isActive
                  ? 'var(--brand-secondary)'
                  : 'var(--palette-blue-400)'
              }
              isBold={isActive}
              style={{ transition: 'color 0.18s' }}
            >
              {option.label}
            </Text.Medium>
          </styled.button>
        )
      })}
    </styled.div>
  )
}
